import React from 'react';
import cn from 'classname';

const Row = (props) => {
	const { row, intervals, can, isHiddenCells, periodSwitch, isHiddenProfit } = props;
	const dates = intervals || [];
	const datesNumber = dates.length || null;

	const total_approved = Number(row[`total_approved`]) || 0;
	const total_all_statuses = Number(row[`total_all_statuses`]) || 0;
	const total_valid = Number(row[`total_valid`]) || 0;

	const all_statuses_approve_percent = row[`total_all_statuses_approve_percent`]
		|| (total_all_statuses > 0 ? 100 * total_approved / total_all_statuses : 0);

	const valid_approve_percent = row[`total_valid_approve_percent`]
		|| (total_valid > 0 ? 100 * total_approved / total_valid : 0);

	return (
		<tr>
			<td className="fixed-col hover-pointer first-affiliate-col">
				<p>{row.admin_email}</p>
				<p>{row.affiliate_email} ({row.affiliate_id})</p>
			</td>
			<td className={cn({'top-affiliates-table-cell_description': true, 'display-none': isHiddenCells })}>
				<p className="flex-center">
					<span className="width-50-p padding-0-5 text-right">
						{Math.round((row[`total_all_statuses`] || 0) / datesNumber)}
					</span>|
					<span className="width-50-p padding-0-5 text-left light-green-text">
						{Math.round((row[`total_approved`] || 0) / datesNumber)}
					</span>
				</p>
				<p className="flex-center">
					<span className="width-50-p padding-0-5 text-right">
						{Math.round(all_statuses_approve_percent)}%
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{Math.round(valid_approve_percent)}%
					</span>
				</p>
				{ can('viewProfit') && !isHiddenProfit &&
					<p className="flex-center">
						Profit {Math.round((row[`total_profit_usd`] || 0) / datesNumber)}$
					</p>
				}
			</td>
			{
				dates.map((item, key, arr) =>
					<ConversionsDateCell {...props} key={key} item={item} index={key} arr={arr} periodSwitch={periodSwitch} />
				)
			}
			<td className={cn({'top-affiliates-table-cell_description': true, 'display-none': isHiddenCells })}>
				<p className="flex-center">
					<span className="width-50-p padding-0-5 text-right">
						{row[`total_all_statuses`] || 0}
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{row[`total_approved`] || 0}
					</span>
				</p>
				<p className="flex-center">
					<span className="width-50-p padding-0-5 text-right">
						{Math.round(all_statuses_approve_percent)}%
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{Math.round(valid_approve_percent)}%
					</span>
				</p>
				{can('viewAll') && <p className="flex-center">Profit {Math.round(row[`total_profit_usd`]) || 0}</p>}
			</td>
		</tr>
	);
};

const ConversionsDateCell = props => {
	const { item, arr, can, row, index, isHiddenCells, isHiddenProfit } = props;

	const isMoreThenBefore = !!arr[index + 1] &&
		Number(row[`${item}_all_statuses`]) > Number(row[`${arr[index + 1]}_all_statuses`]);

	const isLessThenBefore = !!arr[index + 1] &&
		Number(row[`${item}_all_statuses`]) < Number(row[`${arr[index + 1]}_all_statuses`]);

	const approved = Number(row[`${item}_approved`]) || 0;
	const all_statuses = Number(row[`${item}_all_statuses`]) || 0;
	const valid = Number(row[`${item}_valid`]) || 0;

	const all_statuses_approve_percent = row[`${item}_all_statuses_approve_percent`]
		|| (all_statuses > 0 ? 100 * approved / all_statuses : 0);

	const valid_approve_percent = row[`${item}_valid_approve_percent`]
		|| (valid > 0 ? 100 * approved / valid : 0);

	return <td
		className={cn({'top-affiliates-table-cell_description': true, 'display-none': isHiddenCells })}
	>
		<p className='flex-center'>
			<span className="width-50-p padding-0-5 text-right">
				{`${row[`${item}_all_statuses`] || 0} `}
			</span>|
			<span className=" width-50-p padding-0-5 text-left light-green-text">
				{` ${row[`${item}_approved`] || 0}`}
				<span className={cn({ 'less': isLessThenBefore, 'more': isMoreThenBefore })}></span>
			</span>
		</p>
		<p className='flex-center'>
			<span className="width-50-p padding-0-5 text-right">
				{`${Math.round(all_statuses_approve_percent)} `}%
			</span>|
			<span className=" width-50-p padding-0-5 text-left light-green-text">
				{` ${Math.round(valid_approve_percent)}`}%
			</span>
		</p>
		{can('viewProfit') && !isHiddenProfit &&
			<p className="text-center">Profit {Math.round(row[`${item}_profit_usd`]) || 0}$</p>
		}
	</td>;
};

export default Row;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-countries/components/table/expanded-affiliate-row.js